export default "__VITE_ASSET__Cf5a7dE6__"